import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getEarnSunsetNextBoundary, getEarnSunsetPhase } from '@flipster/utils/earn-sunset';

const maxTimeoutMs = 2_147_483_647;

export const earnSunsetPhaseBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);

  const isHydratedAtom = atom(false);
  const nowAtom = atom(Date.now());

  bunja.effect(() => {
    store.set(isHydratedAtom, true);
    store.set(nowAtom, Date.now());

    if (typeof window === 'undefined') return;

    let timeoutId: number | undefined;

    const schedule = () => {
      const next = getEarnSunsetNextBoundary(store.get(nowAtom));
      if (next == null) return;
      const delay = Math.min(Math.max(next - Date.now() + 50, 0), maxTimeoutMs);
      timeoutId = window.setTimeout(() => {
        store.set(nowAtom, Date.now());
        schedule();
      }, delay);
    };

    schedule();

    return () => {
      if (timeoutId != null) window.clearTimeout(timeoutId);
    };
  });

  const phaseAtom = atom((get) => {
    if (!get(isHydratedAtom)) return 'pre-buffer' as const;
    return getEarnSunsetPhase(get(nowAtom));
  });

  const isEarnSunsetBufferAtom = atom((get) => get(phaseAtom) === 'buffer');
  const isFlipsterEarnHiddenAtom = atom((get) => get(phaseAtom) === 'hidden');

  return {
    isHydratedAtom,
    nowAtom,
    phaseAtom,
    isEarnSunsetBufferAtom,
    isFlipsterEarnHiddenAtom,
  };
});
earnSunsetPhaseBunja.debugLabel = 'earnSunsetPhaseBunja';
